import { useEffect, useState, useCallback } from "react";
import { getInventoryTransactionsByHistoryId } from "../../api/inventoryService";
import { getInventoryTransactionsByHistoryEntryId } from "../../api/inventoryService";

export const useHistoryInventoryTransactions = (id, entryId, trigger, initialPage = 1, initialLimit = 10, initialSort = 'date', initialOrder = 'desc') => {
    const [transactions, setTransactions] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: initialSort,
        order: initialOrder,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
        setLoading(true);
        try {
          let response;
          if (entryId)
          {
            response = await getInventoryTransactionsByHistoryEntryId(entryId, page, limit, search);
          }
          else {
            response = await getInventoryTransactionsByHistoryId(id, page, limit, search);
          }
          setTransactions(prev => {
          if (append) {
              return {
              ...response,
              data: [...(prev.data || []), ...response.data],
              };
          }
          // 🔑 Reset pagination when not appending (fresh search or initial load)
          return {
              ...response,
              pagination: { ...response.pagination, page }, 
          };
          });
          return response;
        } catch (err) {
            console.error("Failed to fetch inventory transactions:", err);
        } finally {
            setLoading(false);
        }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = transactions.pagination.page + 1;
        if (nextPage <= transactions.pagination.totalPages) {
        await fetchData(nextPage, transactions.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, transactions.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { transactions, loading, loadMore, searchFunction, resetParent };
};